<template>
  <div v-show="showBubble" class="bubble-box" :class="{'hide-bubble-box': !showBubble}">
    <div class="frame">+{{value}}</div>
    <div class="triangle"></div>
  </div>
</template>

<script>
export default {
  name: 'SytScreenBubble',

  data () {
    return {
      value: 1923.1,
      showBubble: false,
      timer: null
    }
  },

  created () {
    this.init()
  },

  props: {
    min: Number,
    max: Number
  },

  methods: {
    init () {
      if (this.timer !== null) clearInterval(this.timer)
      const a = Math.round(Math.random() * (4 - 0) + 0)
      if (a == 0 || a == 1) {
        this.value = (Math.round(Math.random() * (this.max - this.min + 1) + this.min) + Math.random()).toFixed(2)
        this.showBubble = true
        this.timer =  setTimeout(() => {
          this.showBubble = false
          this.init()
        }, Math.round(Math.random() * 5) * 1000)
      } else {
        this.timer =  setTimeout(() => {
          this.init()
        }, Math.round(Math.random() * 40) * 1000)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bubble-box {
  position: relative;
  width: 100px;
  height: 25px;
  color: #000;
  opacity: 1;
  animation: all 2s;
}
.frame {
  width: 100px;
  height: 25px;
  border-radius: 15px;
  text-align: center;
  line-height: 25px;
  background-color: #ffd800;
}
.triangle {
  position: absolute;
  right: 20px;
  bottom: -19px;
  width: 0;
  height: 0;
  border: 10px solid #ffd800;
  border-color: #ffd800 transparent transparent transparent;
}
.hide-bubble-box {
  opacity: 0;
}
</style>